import React from 'react';
import { useTranslation } from 'react-i18next';
import NavButtons from '../components/NavButtons';
import SelectionCard from '../components/SelectionCard';
import StepHeading from '../components/StepHeading';
import { CHALLENGES } from '../bookDemoConstants';

interface ChallengesStepProps {
  value: string[];
  onChange: (ids: string[]) => void;
  onBack: () => void;
  onContinue: () => void;
}

const ChallengesStep: React.FC<ChallengesStepProps> = ({ value, onChange, onBack, onContinue }) => {
  const { t } = useTranslation();

  const toggle = (id: string) =>
    onChange(value.includes(id) ? value.filter(v => v !== id) : [...value, id]);

  return (
    <div className="flex flex-col flex-1">
      <StepHeading title={t('bookDemo.challenges.title')} subtitle={t('bookDemo.challenges.subtitle')} />

      <div className="grid grid-cols-2 gap-2.5 sm:gap-5 max-w-[846px] mx-auto w-full">
        {CHALLENGES.map(challenge => (
          <SelectionCard
            key={challenge.id}
            title={t(`bookDemo.challenges.options.${challenge.id}.title`)}
            description={t(`bookDemo.challenges.options.${challenge.id}.description`)}
            icon={challenge.icon}
            selected={value.includes(challenge.id)}
            onClick={() => toggle(challenge.id)}
            variant="challenge"
          />
        ))}
      </div>

      <NavButtons onBack={onBack} onContinue={onContinue} continueDisabled={value.length === 0} />
    </div>
  );
};

export default ChallengesStep;
